module.exports = __webpack_public_path__ + "img/Avatar-30.ac5edcc7.svg";